import { render, staticRenderFns } from "./password.vue?vue&type=template&id=7f7fc47b&"
import script from "./password.vue?vue&type=script&lang=ts&"
export * from "./password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports